export const BEHAVIOR = 'Behavior';
export const CHECKMARKS = 'Checkmarks';
export const CHIP = 'Chip';
export const DEFAULT = 'Default';
export const CHECKBOX = 'Checkbox';
export const BUILDER_COMPONENTS_MULTISELECT = 'BuilderComponentsMultiselect';
export const BUILDER_COMPONENTS_FORM_MULTISELECT = 'BuilderComponentsFormMultiselect';
